module.exports = __webpack_public_path__ + "img/NCR.5f049380.png";